@defer(when chatService.firstBatchLoaded | async){
  @if(showEmptyState()) {
    @if(showStorySetupWizard()) {
      <div class="chat-setup-shell">
        <re-story-setup-wizard
          [storyId]="storyId()"
          [characters]="storyCharacters()"
          [ownerNames]="storyOwnerNames()"
          [currentUserId]="currentUserId()"
          [submitting]="storySetupSubmitting()"
          [phase]="storySetupWizardPhase()"
          [settingBrief]="storySettingBrief()"
          [savedAnswers]="savedStorySetupAnswers()"
          (preferencesCommitted)="preferencesCommitted.emit($event)"
          (completed)="storySetupCompleted.emit($event)"
        />
      </div>
    } @else if (showCreateCharacterCta()) {
      <div class="chat-empty re-empty-state">
        <div class="chat-empty__icon chat-empty__icon--ai re-empty-state__icon">
          <ion-icon name="person-add-outline"></ion-icon>
        </div>
        <p class="chat-empty__title re-empty-state__title">{{ 'chat.storySetup.step2Title' | translate }}</p>
        <p class="chat-empty__hint re-empty-state__description">{{ 'chat.storySetup.step2HintWithSetting' | translate }}</p>
        <ion-button
          class="chat-empty__cta chat-empty__cta--narrator re-empty-state__action"
          shape="round"
          (click)="createCharacter.emit()">
          <ion-icon slot="start" name="person-add-outline"></ion-icon>
          {{ 'chat.storySetup.createCharacter' | translate }}
        </ion-button>
      </div>
    } @else if (showStartAdventureCta()) {
      <div class="chat-empty re-empty-state">
        <div class="chat-empty__icon chat-empty__icon--ai re-empty-state__icon">
          <ion-icon name="sparkles-outline"></ion-icon>
        </div>
        <p class="chat-empty__title re-empty-state__title">{{ 'chat.storySetup.step3Title' | translate }}</p>
        <p class="chat-empty__hint re-empty-state__description">{{ 'chat.storySetup.step3Hint' | translate }}</p>
        <ion-button
          class="chat-empty__cta chat-empty__cta--narrator re-empty-state__action"
          shape="round"
          [disabled]="storySetupSubmitting()"
          (click)="startAdventure.emit()">
          <ion-icon slot="start" name="sparkles-outline"></ion-icon>
          {{ 'chat.storySetup.startAdventure' | translate }}
        </ion-button>
      </div>
    } @else if (showWaitingForHost()) {
      <div class="chat-empty re-empty-state">
        <div class="chat-empty__icon chat-empty__icon--ai re-empty-state__icon">
          <ion-icon name="sparkles-outline"></ion-icon>
        </div>
        <p class="chat-empty__title re-empty-state__title">{{ 'chat.waitingForHost.title' | translate }}</p>
        <p class="chat-empty__hint re-empty-state__description">{{ 'chat.waitingForHost.hint' | translate }}</p>
        @if(!currentUserHasCharacter()) {
          <ion-button
            class="chat-empty__cta chat-empty__cta--narrator re-empty-state__action"
            shape="round"
            (click)="createCharacter.emit()">
            <ion-icon slot="start" name="person-add-outline"></ion-icon>
            {{ 'chat.waitingForHost.createCharacter' | translate }}
          </ion-button>
        }
      </div>
    } @else if (showStoryStartingWait()) {
      <div class="chat-empty chat-empty--wait re-empty-state">
        <div class="chat-empty__loader" aria-hidden="true">
          <ion-spinner name="crescent" color="medium"></ion-spinner>
        </div>
        <p class="chat-empty__title re-empty-state__title">{{ 'chat.storySetup.settingWaitTitle' | translate }}</p>
        <p class="chat-empty__hint re-empty-state__description">{{ 'chat.storySetup.settingWaitHint' | translate }}</p>
        <p class="chat-empty__progress">{{ 'chat.storySetup.settingWaitProgress' | translate }}</p>
      </div>
    } @else if (showSettingRetryCta()) {
      <div class="chat-empty re-empty-state">
        <div class="chat-empty__icon chat-empty__icon--ai re-empty-state__icon">
          <ion-icon name="alert-circle-outline"></ion-icon>
        </div>
        <p class="chat-empty__title re-empty-state__title">{{ 'chat.storySetup.settingFailedTitle' | translate }}</p>
        <p class="chat-empty__hint re-empty-state__description">{{ 'chat.storySetup.settingFailedHint' | translate }}</p>
        <ion-button
          class="chat-empty__cta chat-empty__cta--narrator re-empty-state__action"
          shape="round"
          [disabled]="storySetupSubmitting()"
          (click)="retrySetting.emit()">
          <ion-icon slot="start" name="refresh-outline"></ion-icon>
          {{ 'chat.storySetup.retrySetting' | translate }}
        </ion-button>
      </div>
    } @else {
    <div class="chat-empty re-empty-state">
      <div class="chat-empty__icon re-empty-state__icon" [class.chat-empty__icon--ai]="isAiChat()">
        <ion-icon [name]="isAiChat() ? 'sparkles-outline' : 'chatbubbles-outline'"></ion-icon>
      </div>
      <p class="chat-empty__title re-empty-state__title">{{ 'chat.empty.title' | translate }}</p>
      @if(isAiChat()) {
        <p class="chat-empty__hint re-empty-state__description" [innerHTML]="'chat.empty.aiHint' | translate"></p>
        <ion-button
          class="chat-empty__cta chat-empty__cta--narrator re-empty-state__action"
          shape="round"
          (click)="invokeMaster.emit()">
          <ion-icon slot="start" name="sparkles-outline"></ion-icon>
          {{ 'chat.empty.callMaster' | translate }}
        </ion-button>
      } @else if (isLoreChat()) {
        <p class="chat-empty__hint re-empty-state__description" [innerHTML]="'chat.empty.loreHint' | translate"></p>
        <ion-button
          class="chat-empty__cta chat-empty__cta--narrator re-empty-state__action"
          shape="round"
          (click)="openLoreAlert()">
          <ion-icon slot="start" name="help-circle-outline"></ion-icon>
          {{ 'chat.empty.callLore' | translate }}
        </ion-button>
      } @else {
        <p class="chat-empty__hint re-empty-state__description">
          {{ 'chat.empty.standardHint' | translate }}
        </p>
      }
    </div>
    }
  } @else {
  <re-virtual-scroll-viewport
    class="rr-chat-viewport"
    [class.rr-chat-viewport--master-loading]="chatService.masterLoading()"
    (reInfiniteTop)="chatService.loadMoreMessagesTop($event)"
    (reInfiniteBottom)="chatService.loadMoreMessagesBottom($event)"
    [scrollElement]="scrollElement()"
  >
    <div
      *reVirtualScrollList="
        let message of chatService.list();
        let visible = visible;
        direction: chatService.direction();
        bufferSize: chatService.bufferSize();
        startingElement: chatService.startingElement();
        trackBy: chatService.trackBy;
        topReached: chatService.topReached();
        bottomReached: chatService.bottomReached();
        emptyListStartingIndex: '0'
      "
    >
      <re-message
        *reVirtualScrollElement="visible"
        [message]="message"
        [usePrivateMessageLayout]="usePrivateMessageLayout()"
        [allowCharacters]="allowCharacters()"
        [masterLoading]="chatService.masterLoading()"
        [isLatestMasterMessage]="isLatestMasterMessage(message)"
        [allowSaveBookmark]="allowBookmark()"
        [allowSaveChapter]="allowSaveChapter()"
        (sendSuggestedRoll)="sendSuggestedRoll.emit($event)"
        (suggestedActionClick)="suggestedActionClick.emit($event)"
        (sendSuggestedMessage)="sendSuggestedMessage.emit($event)"
        (saveBookmark)="saveBookmark.emit($event)"
        (removeBookmark)="removeBookmark.emit($event)"
        (saveChapter)="saveChapter.emit($event)"
        (removeChapter)="removeChapter.emit($event)"
        (goToMessage)="scrollTo($event)"
        (quoteMessage)="quoteMessageHandler(message)"
        (showProfile)="showProfile.emit($event)"
        (showCharacter)="showCharacter.emit($event)"
      >
      </re-message>
    </div>
    <div slot="bottomLoader">
      <ion-spinner></ion-spinner>
    </div>
    <div slot="topLoader">
      <ion-spinner></ion-spinner>
    </div>
    @if (shouldShowMasterBanner()) {
    <div slot="footer" class="master-invite master-invite--ai">
      <button
        type="button"
        class="master-invite__card"
        (click)="openMasterAlert()"
        [attr.aria-label]="'chat.invokeMaster.prompt' | translate"
      >
        <div class="master-invite__header">
          <span class="master-invite__badge" aria-hidden="true">
            <ion-icon name="sparkles-outline"></ion-icon>
          </span>
          <span class="master-invite__label">{{ 'chat.message.master' | translate }}</span>
        </div>
        <p class="master-invite__hint">{{ 'chat.invokeMaster.bannerHint' | translate }}</p>
        <span class="master-invite__action">
          {{ 'chat.invokeMaster.prompt' | translate }}
          <ion-icon name="chevron-forward" aria-hidden="true"></ion-icon>
        </span>
      </button>
    </div>
    }
    @if (shouldShowLoreBanner()) {
    <div slot="footer" class="master-invite master-invite--ai lore-invite">
      <button
        type="button"
        class="master-invite__card"
        (click)="openLoreAlert()"
        [attr.aria-label]="'chat.invokeLore.prompt' | translate"
      >
        <div class="master-invite__header">
          <span class="master-invite__badge" aria-hidden="true">
            <ion-icon name="help-circle-outline"></ion-icon>
          </span>
          <span class="master-invite__label">{{ 'chat.lore.label' | translate }}</span>
        </div>
        <p class="master-invite__hint">{{ 'chat.invokeLore.bannerHint' | translate }}</p>
        <span class="master-invite__action">
          {{ 'chat.invokeLore.prompt' | translate }}
          <ion-icon name="chevron-forward" aria-hidden="true"></ion-icon>
        </span>
      </button>
    </div>
    }
  </re-virtual-scroll-viewport>
  @if (showSetupWizardOverlay()) {
    <div class="chat-setup-overlay">
      <re-story-setup-wizard
        [storyId]="storyId()"
        [characters]="storyCharacters()"
        [ownerNames]="storyOwnerNames()"
        [currentUserId]="currentUserId()"
        [submitting]="storySetupSubmitting()"
        [phase]="storySetupWizardPhase()"
        [settingBrief]="storySettingBrief()"
        [savedAnswers]="savedStorySetupAnswers()"
        [compact]="true"
        (preferencesCommitted)="preferencesCommitted.emit($event)"
        (completed)="storySetupCompleted.emit($event)"
      />
    </div>
  }
  }
} @placeholder {
<div class="defer-spinner">
  <ion-spinner></ion-spinner>
</div>
}
<ion-loading [isOpen]="loadingNewMessages"></ion-loading>
